<div class="mapping-container">
  <app-data-model-column-mapping-source *ngIf="dataModel?.data_model_type === dataModelTypes.SOURCE"
                                  [datasource_column]="column"></app-data-model-column-mapping-source>

  <app-data-model-column-mapping-target *ngIf="dataModel?.data_model_type === dataModelTypes.TARGET"
                                  [datasource_column]="column"></app-data-model-column-mapping-target>
</div>
